import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { EasyonReveal } from "./EasyonMotion";

export const EasyonFinalCtaSection = () => {
    const navigate = useNavigate();

    return (
        <section className="eo-cta">
            <div className="eo-container">
                <EasyonReveal>
                    <div className="eo-cta__banner">
                        <h2>Ready to Simplify Business Operations?</h2>
                        <p>
                            Manage quotations, inventory, billing, compliance, and operations from a single platform.
                        </p>
                        <div className="eo-cta__actions">
                            <Button className="eo-btn eo-btn--light" onClick={() => navigate("/contact")}>
                                Request Demo <ArrowRightOutlined />
                            </Button>
                            <Button className="eo-btn eo-btn--outline-light" onClick={() => navigate("/contact")}>
                                Get Started
                            </Button>
                        </div>
                    </div>
                </EasyonReveal>
            </div>
        </section>
    );
};
